import { gql } from '@lcs/shared/api';

export const getTilesTileSet = gql`
   fragment TileSetFields on TileSet {
      tileSetId
      name
      description
      designerDescription
      tileSetTypeConnection {
         items {
            tileSetTypeId
            tile {
               tileId
               description
               typeId
            }
         }
      }
   }

   query GetTilesTileSet($filters: String!) {
      tilesConnection(filters: $filters) {
         items {
            tileId
            tileSetType {
               tileSetTypeId
               tileSet {
                  ...TileSetFields
               }
            }
         }
      }
   }
`;
